export const InvoiceTypeConstants = {
  Standard: 'e68714ae-4194-42d1-ab0b-ab7b4143bbed',
  CreditNote: 'abf9a7de-bb80-48dd-98da-d6ca36736f26',
} as const;

export const InvoiceStatusConstants = {
  Draft: 'a82b24ae-8de3-429c-ac9b-99a9d45a3aa7',
  Issued: '4e2195bf-96fa-426e-89bc-181d528edf70',
  Paid: '10f8a656-1842-4558-bb95-f00da56fe980',
  PartiallyPaid: '8337f1e1-a0d2-464f-bcea-4f6461635f47',
  Credited: '5e80a999-2840-451b-b169-44e7adf2963c',
  Cancelled: '548811c1-e272-44cf-bc98-1ced87adb4c7',
} as const;

export type InvoiceTypeId = typeof InvoiceTypeConstants[keyof typeof InvoiceTypeConstants];
export type InvoiceStatusId = typeof InvoiceStatusConstants[keyof typeof InvoiceStatusConstants];